import axios from "axios";
import { TTP_API_URL } from "Config";

export const getTTPUser = ({ userId, token }) => {
  const filter = [
    {
      property: "id",
      value: userId,
      operator: "eq"
    }
  ];

  const fields = [
    "*",
    // "communities",
    "uid",
    "avatar",
    "description",
    "contactSocialNetworks",
    "cover",
    "url",
    "role",
    // "roles",
    "dataUserOrganizations",
    "selectedOrganization"
  ];

  const requestUrl = `${TTP_API_URL}/organization/user`;

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(",")
  };

  return axios.get(requestUrl, {
    //cancelToken: getLatestArticlesSourceToken.token,
    params
  });
};

export const setCurrentOrganization = (token, client) => {
  const requestUrl = `${TTP_API_URL}/organization/user/save-selected-organization`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", client.id);

  return axios.post(requestUrl, formData);
};

export const getNotifications = (token, userId, navCommunity, options) => {
  let filter = [
    {
      property: "status",
      value: "PUBLISHED",
      operator: "eq"
    }
  ];
  if (navCommunity) {
    filter.push({
      property: "folder",
      value: navCommunity.id,
      operator: "eq"
    });
  } else {
    filter.push({
      property: "folder",
      value: "",
      operator: "null"
    });
  }

  let fields = ["*", "isRead", "introduction"];
  let sort = [
    {
      property: "publishedAt",
      dir: "desc"
    }
  ];

  const requestUrl = `${TTP_API_URL}/blog/notification-user/${userId}`;

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    sort: JSON.stringify(sort),
    limit: options && options.limit ? options.limit : 10
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/auth.js